module.exports = __webpack_public_path__ + "static/img/13.7db52b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/sp/13.png
// module id = b0BJ
// module chunks = 0